export default __webpack_public_path__ + "static/media/logo192x192.eae8f57c.png";